// Role-classification helpers shared by the `/china-rates` and
// `/russia-rates` list pages and the router (#1750: moved out of the China
// `requests/filters.ts` so the Russia feature does not deep-import China
// internals).
import type { User } from '@magimp/shared';

/**
 * @aiPurpose role axis used by the hidden-status filter helpers below
 *   (#1159 PR5). Independent of the China-only `RoleKind` so the same
 *   helpers serve `/russia-rates` for `logist_ru`. Unknown / missing
 *   user maps to `'manager'`; admin keeps full visibility.
 */
export type StatusFilterRole = 'admin' | 'manager' | 'logist_cn' | 'logist_ru';

export function detectStatusFilterRole(user: User | null): StatusFilterRole {
  if (!user) return 'manager';
  // WHY: legacy fixtures and a handful of route-gate tests construct a
  //   `user` payload without a fully-populated `.role.name` field. The
  //   safe fallback collapses to the non-logist default so the
  //   page-render path stays alive.
  const raw = user.role?.name;
  if (typeof raw !== 'string') return 'manager';
  const n = raw.toLowerCase();
  if (n === 'admin') return 'admin';
  // INVARIANT (#1159 PR5): the legacy `'logist'` seed name (backend
  //   `roles.service.ts` keeps it alongside `'logist_cn'` for rolling-
  //   deploy / snapshot-restore compatibility) maps to the China-side
  //   logist role here, mirroring `detectRoleKind`.
  if (n === 'logist_cn' || n === 'logist') return 'logist_cn';
  if (n === 'logist_ru') return 'logist_ru';
  return 'manager';
}

export function isLogistStatusFilterRole(role: StatusFilterRole): boolean {
  return role === 'logist_cn' || role === 'logist_ru';
}
